import axios from "axios";
import Swal from "sweetalert2";

import {
  decryption,
  encryption,
  getFromLocalStorage,
} from "../utils/common-utils";

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
});
const axiosInstanceWithoutEnc = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("token")) {
      if (config.data) {
        let encryptedPayload =
          // encryption(JSON.stringify(
          config.data;
        // ));
        config.data = encryptedPayload;
      }
      config.headers["Authorization"] = `Bearer ${localStorage.getItem(
        "token"
      )}`;
      config.headers["Content-Type"] = "application/json";
      config.headers["userId"] = getFromLocalStorage("userData")?.id;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response?.data) {
      let decryptedResponse =
        // JSON.parse(decryption(
        response?.data;
      // ));

      if (
        decryptedResponse?.statusDescription?.status == 401 &&
        !response?.config?.url?.toLowerCase()?.includes("/auth/v1/logout")
      ) {
        Swal.fire({
          title: "Session Expired",
          text: "Your session has expired. Please log in again.",
          icon: "warning",
          confirmButtonText: "OK",
        }).then(() => {
          localStorage.clear();
          setTimeout(() => {
            window.location.href = "/";
          }, 2000);
        });
      }
      return decryptedResponse;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstanceWithoutEnc.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("token")) {
      config.headers["Authorization"] = `Bearer ${localStorage.getItem(
        "token"
      )}`;
      config.headers["Content-Type"] = "application/json";
      config.headers["userId"] = getFromLocalStorage("userData")?.id;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstanceWithoutEnc.interceptors.response.use(
  (response) => {
    if (response?.data) {
      let decryptedResponse =
        // JSON.parse(decryption(
        response?.data;
      // ));
      if (
        decryptedResponse?.data?.statusDescription?.status == 401 &&
        !response?.config?.url?.toLowerCase()?.includes("/auth/v1/logout")
      ) {
        Swal.fire({
          title: "Session Expired",
          text: "Your session has expired. Please log in again.",
          icon: "warning",
          confirmButtonText: "OK",
        }).then(() => {
          localStorage.clear();
          setTimeout(() => {
            window.location.href = "/";
          }, 2000);
        });
      }

      return decryptedResponse;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { axiosInstance, axiosInstanceWithoutEnc };
